
export default (theme) => ({
  categoryTitle: {
    flex: 1,
    margin: 0,
  },
  layout: { width: 'auto' },
  card: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  cardContent: { flexGrow: 1 },
  searchField: {
    margin: theme.spacing(1),
    float: 'right',
  },
  paginationContainer: {
    float: 'right',
    marginTop: theme.spacing(2),
  },
  alignCenter: { textAlign: 'center' },
  action: { margin: 0 },
  header: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: '1rem',
  },
});
